function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { connect } from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";
import BlankSpace from "../../styled/BlankSpace";
const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  float: right;
  cursor: pointer;
`;
export default ((title, ChildComponent, {
  mapStateToProps: mapChildStateToProps,
  mapDispatchToProps: mapChildDispatchesToProps
}) => {
  class ComposedComponent extends Component {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "state", {
        isFormShown: false
      });

      _defineProperty(this, "componentDidUpdate", (prevProps, prevState, snapshot) => {
        if (this.props.formListening) {
          this.toggleForm();
          this.props.stopListenSection();
        }
      });

      _defineProperty(this, "toggleForm", () => {
        this.setState(prevState => ({
          isFormShown: !prevState.isFormShown
        }), () => {
          if (!!mapChildDispatchesToProps.resetSection && !this.state.isFormShown) {
            this.props.resetSection();
          }
        });
      });

      _defineProperty(this, "renderToggle", () => {
        if (!this.props.disableChange) {
          return /*#__PURE__*/React.createElement(StyledFontAwesomeIcon, {
            icon: this.state.isFormShown ? faTimes : faEdit,
            onClick: this.toggleForm,
            cypress: 'toggleCardToggle'
          });
        }
      });

      _defineProperty(this, "renderTitle", () => {
        return /*#__PURE__*/React.createElement(React.Fragment, null, title, " ", this.renderToggle());
      });

      _defineProperty(this, "render", () => {
        return /*#__PURE__*/React.createElement(Card, {
          cypress: this.props.cypress
        }, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(CardTitle, {
          tag: "h5"
        }, this.renderTitle()), /*#__PURE__*/React.createElement(BlankSpace, {
          rem: 1
        }), /*#__PURE__*/React.createElement(ChildComponent, _extends({}, this.props, {
          isFormShown: this.state.isFormShown,
          toggleForm: this.toggleForm,
          renderToggle: this.renderToggle
        }))));
      });
    }

  }

  function mapStateToProps(state) {
    return mapChildStateToProps(state);
  }

  return connect(mapStateToProps, mapChildDispatchesToProps)(ComposedComponent);
});